import { render, staticRenderFns } from "./IconSilver.vue?vue&type=template&id=a35bcd50&scoped=true&"
import script from "./IconSilver.vue?vue&type=script&lang=js&"
export * from "./IconSilver.vue?vue&type=script&lang=js&"
import style0 from "./IconSilver.vue?vue&type=style&index=0&id=a35bcd50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35bcd50",
  null
  
)

export default component.exports